var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AiHead'),(!_vm.MenuFilters.includes(`${this.$router.history.current.name}`))?_c('AIMenu'):_vm._e(),_c('AiPersonalCenter'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }